export const REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER: UserRoles[] = [
  'ROLE_ADMIN',
  'ROLE_DEVELOPER',
];
